import { MutationTree } from 'vuex';
import { UndergradCycleState } from '@/store/undergrad/cycle/state';
import { UndergradCycle } from '@/models/undergrad/undergrad-cycle.model';

const mutations: MutationTree<UndergradCycleState> = {
  SET_CYCLES(state: UndergradCycleState, entities: UndergradCycleState) {
    if (!entities.undergradCycles) {
      state.undergradCycles = [];
      return;
    }

    state.undergradCycles = Object.values(entities.undergradCycles);
  },

  SET_CURRENT_CYCLE(state: UndergradCycleState, cycle: UndergradCycle) {
    if (!cycle) {
      return;
    }

    state.currentCycle = cycle;
  },
};

export default mutations;
